"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicantInfoCommandToJSON = exports.ApplicantInfoCommandFromJSONTyped = exports.ApplicantInfoCommandFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function ApplicantInfoCommandFromJSON(json) {
    return ApplicantInfoCommandFromJSONTyped(json, false);
}
exports.ApplicantInfoCommandFromJSON = ApplicantInfoCommandFromJSON;
function ApplicantInfoCommandFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'contact': _1.PreContactStepFromJSON(json['contact']),
        'mailingAddress': !runtime_1.exists(json, 'mailingAddress') ? undefined : _1.AddressFromJSON(json['mailingAddress']),
        'clearPromotionsOptIn': json['clearPromotionsOptIn'],
    };
}
exports.ApplicantInfoCommandFromJSONTyped = ApplicantInfoCommandFromJSONTyped;
function ApplicantInfoCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'contact': _1.PreContactStepToJSON(value.contact),
        'mailingAddress': _1.AddressToJSON(value.mailingAddress),
        'clearPromotionsOptIn': value.clearPromotionsOptIn,
    };
}
exports.ApplicantInfoCommandToJSON = ApplicantInfoCommandToJSON;
//# sourceMappingURL=ApplicantInfoCommand.js.map